import Vue from 'vue';
import Router from 'vue-router';
import RegisterMeuFinanciamento from './views/meu-financiamento/RegisterMeuFinanciamento.vue';

Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      name: '404',
      beforeEnter() {
        window.location.href = 'https://www.omni.com.br/404';
      },
    },
    {
      path: '/',
      name: 'root',
      redirect: {
        name: 'register-meu-financiamento',
      },
    },
    {
      path: '/cadastro-meu-financiamento',
      name: 'register-meu-financiamento',
      component: RegisterMeuFinanciamento,
    },
    {
      path: '/cadastro-blocks',
      name: 'cadastro-blocks',
      redirect: {
        name: 'register-meu-financiamento',
      },
    }
  ],
});
